import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {PermissionTemplateContainerModel} from '../../../../../models/aggregates/permissions';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PermissionTemplateService extends BaseApiTemplateService<PermissionTemplateContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX +'app-permission-templates';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX +'app-permission-templates';
    this.httpClient = http;
  }

  private setUrl(endpoint: string){
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-permission-templates' + endpoint;
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-permission-templates' + endpoint;
  }

  sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
    this.setUrl('/sysadmin-ep');
    return super.getByCriteria(pagination, apiVisa);
  }

  getByLogin(
    appletGuid: string,
    tenantGuid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<PermissionTemplateContainerModel>> {
    let url = this.apiUrl + "/login-ep/" + appletGuid + "/" + tenantGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/login-ep/" + appletGuid + "/" + tenantGuid;
    }
    return this.httpClient.get<ApiResponseModel<PermissionTemplateContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public getByGuidByLogin(
    tenantCode: string,
    appletGuid: string,
    guid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<PermissionTemplateContainerModel>> {
    let url = this.apiUrl + '/login-ep/' + tenantCode + '/' + appletGuid; 
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/login-ep/' + tenantCode + '/' + appletGuid;
    }
    return this.httpClient.get<ApiResponseModel<PermissionTemplateContainerModel>>(
      url + '/' + guid,
      this.getHttpHeader(visa)
    );
  }
  
  getByTenantAdmin(
    tenantCode: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<PermissionTemplateContainerModel>> {
    let url = `${this.apiUrl}/${tenantCode}/tenant-admin-ep`;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${this.endpoint_path}/${tenantCode}/tenant-admin-ep`;
    }
    return this.httpClient.get<ApiResponseModel<PermissionTemplateContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getByGuidTenantAdmin(
    tenantCode: string,
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<PermissionTemplateContainerModel>> {
    let url = `${this.apiUrl}/${tenantCode}/tenant-admin-ep/${guid}`;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${this.endpoint_path}/${tenantCode}/tenant-admin-ep/${guid}`;
    }
    return this.httpClient.get<BasicApiResponseModel<PermissionTemplateContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getByCriteriaTenantAdmin(
    pagination: Pagination,
    tenantCode: string,
    visa: ApiVisa
  ): Observable<PagingResponseModel<PermissionTemplateContainerModel>> {
    const queryParams = pagination.getQueryKeyValues();
    let url = `${this.apiUrl}/${tenantCode}/tenant-admin-ep/query?${queryParams}`;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${this.endpoint_path}/${tenantCode}/tenant-admin-ep/query?${queryParams}`;
    }
    return this.httpClient.get<PagingResponseModel<PermissionTemplateContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

 // /core2/platform/dm/app-permission-templates/custom-retrieve/tenant-admin-ep
   getSelectedTargets(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/custom-retrieve/" + BaseApiTemplateService.TENANT_ADMIN_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}


